export default __webpack_public_path__ + "882b231ed4cd81f912c89d25893c12b7.png";